import styled from "styled-components";

import { CombinedIcon } from "@similarweb/pro-logic-components";
import { Flex } from "@similarweb/ui-components/foundations";

import LeadText from "../LeadText/LeadText";

export const StyledIconTextWrapper = styled(Flex)<{ width: string }>`
    align-items: center;
    flex: 1 0;
    column-gap: 4px;
    min-width: 0;

    width: ${({ width }) => width};
`;

export const StyledCombinedIcon = styled(CombinedIcon)`
    flex-shrink: 0;
    width: 24px;
    height: 24px;
`;

export const StyledLeadText = styled(LeadText)`
    min-width: 0;
    flex-grow: 1;
    flex-basis: 0;
`;
